import React from "react";

function FpgPlusIcon({width,height,color,stroke}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <circle cx="10" cy="10" r="10" fill={color}></circle>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 5v10M15 10H5"
      ></path>
    </svg>
  );
}

export default FpgPlusIcon;
